import { isServer } from 'lib/nextjs'
import { useCallback, useEffect, useState } from 'react'

type DocumentHiddenProps = 'hidden' | 'msHidden' | 'webkitHidden'
type DocumentVisibilityChangeProps =
  | 'visibilitychange'
  | 'msvisibilitychange'
  | 'webkitvisibilitychange'

const getProperties = () => {
  // Set the name of the hidden property and the change event for visibility
  let hidden: DocumentHiddenProps | undefined
  let visibilityChange: DocumentVisibilityChangeProps | undefined

  if (isServer()) return {}

  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden'
    visibilityChange = 'visibilitychange'
    // @ts-expect-error Property 'msHidden' does not exist on type 'Document'. Did you mean 'hidden'?ts(2551)
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden'
    visibilityChange = 'msvisibilitychange'
    // @ts-expect-error Property 'msHidden' does not exist on type 'Document'. Did you mean 'hidden'?ts(2551)
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden'
    visibilityChange = 'webkitvisibilitychange'
  }
  return { hidden, visibilityChange }
}

export const useOnVisibilityChange = (
  callback?: (isHidden: boolean) => void
) => {
  const { hidden, visibilityChange } = getProperties()
  const [documentHidden, setDocumentHidden] = useState(false)

  // If the page is hidden, pause the video;
  // if the page is shown, play the video
  const handleVisibilityChange = useCallback(() => {
    if (!hidden) {
      console.warn('useOnVisibilityChange: document has no hidden property')
      return
    }

    // @ts-expect-error Type property 'msHidden' does not exist on document
    const isHidden = Boolean(document[hidden])

    setDocumentHidden(isHidden)
    callback?.(isHidden)
  }, [hidden, callback])

  useEffect(() => {
    if (visibilityChange) {
      document.addEventListener(visibilityChange, handleVisibilityChange, false)

      return () =>
        document.removeEventListener(visibilityChange, handleVisibilityChange)
    }
  }, [visibilityChange, handleVisibilityChange])

  return { documentHidden }
}
